var Anchor = function () {
  this.$anchorLink = $('.anchor-link__link');
  this.resizeTimer = false;
};

Anchor.prototype = {
  _options: {
    position: 0,
  },
  init: function () {
    this.setSmoothScrollFactory();
    this.addEvents();
  },
  setSmoothScrollFactory: function (isReset) {
    var that = this;
    this.$anchorLink.each(function (_, elem) {
      var _options = that._options;
      var $target = $(elem);
      var $header = $('header');
      var href = $target.attr('href');
      _options.position = $(href).offset().top - ($header.height() + 40);

      if (isReset) SmoothScrollFactory($target).reset(_options);
      else SmoothScrollFactory($target).setOption(_options).setOnClick();
    });
  },
  resetSmoothScrollFactory: function () {
    var isReset = true;
    this.setSmoothScrollFactory(isReset);
  },
  addEvents: function () {
    this.$anchorLink.on('click', function (e) {
      e.preventDefault();
    });
    $(window).on('resize', this.handleResize.bind(this));
  },
  handleResize: function () {
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
    var that = this;
    this.resizeTimer = setTimeout(function () {
      that.resetSmoothScrollFactory();
    }, 100);
  },
};

var Accordion = function () {
  this.$trigger = $('.collection__heading');
  this.resizeTimer = false;
};
Accordion.prototype = {
  className: {
    open: 'is-open',
  },
  windowSize: {
    width: {
      sp: 768,
    },
  },
  init: function () {
    this.addEvents();
  },
  addEvents: function () {
    this.$trigger.on('click', this.handleClickTrigger.bind(this));
    $(window).on('resize', this.handleResize.bind(this));
  },
  handleClickTrigger: function (e) {
    if (window.innerWidth >= this.windowSize.width.sp) return;
    var $target = $(e.currentTarget);
    if ($target.hasClass('collection__heading--link')) return;
    this.accordionToggle($target);
  },
  handleResize: function () {
    var $toggler = $('.collection__container');
    var _that = this;
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(function () {
      if (window.innerWidth < _that.windowSize.width.sp) return;
      $toggler.css('display', '');
      _that.$trigger.removeClass(_that.className.open);
    }, 100);
  },
  accordionToggle: function ($target) {
    var $parent = $target.parents('.collection');
    var $toggler = $parent.find('.collection__container');
    $toggler.stop().slideToggle();
    $target.toggleClass(this.className.open);
  },
};

$(function () {
  var anchor = new Anchor();
  anchor.init();

  var accordion = new Accordion();
  accordion.init();
});

$(document).ready(function () {
  let links = $('.jdgm-write-rev-link');
  links.attr('href', 'javascript:void(0)');
});

$(function () {
  $('#HAIRCARE').hover(
    function () {
      let $menu = $('#drop-down-menu');
      let windowWidth = window.innerWidth;
      $menu.css({ width: windowWidth + 'px' });
      $menu.stop().slideDown(200);
    },
    function () {
      let $menu = $('#drop-down-menu');
      $menu.stop().slideUp(200);
    }
  );
});

$(function () {
  $('#PRODUCTS').hover(
    function () {
      let $menu = $('#drop-down-menu3');
      let windowWidth = window.innerWidth;
      $menu.css({ width: windowWidth + 'px' });
      $menu.stop().slideDown(200);
    },
    function () {
      let $menu = $('#drop-down-menu3');
      $menu.stop().slideUp(200);
    }
  );
});

$(function () {
  $('#NEWS').hover(
    function () {
      let $menu = $('#drop-down-menu4');
      let windowWidth = window.innerWidth;
      $menu.css({ width: windowWidth + 'px' });
      $menu.stop().slideDown(200);
    },
    function () {
      let $menu = $('#drop-down-menu4');
      $menu.stop().slideUp(200);
    }
  );
});

$(function () {
  $('#VALXCOLLABORATION').hover(
    function () {
      let $menu = $('#drop-down-menu-VALX');
      let windowWidth = window.innerWidth;
      $menu.css({ width: windowWidth + 'px' });
      $menu.stop().slideDown(200);
    },
    function () {
      let $menu = $('#drop-down-menu-VALX');
      $menu.stop().slideUp(200);
    }
  );
});

// headerドロップダウンメニュー pc
$(function () {
  $('#drop-down-menu3 .haircare').hover(
    function () {
      $('.ddmTargetHaircare').stop().slideDown(200);
      $('.drop-down__wrapper').css('height', 'auto');
    },
    function () {
      $('.ddmTargetHaircare').stop().slideUp(200);
      $('.drop-down__wrapper').css('height', 'initial');
    }
  );
  $('#drop-down-menu3 .skincare').hover(
    function () {
      $('.ddmTargetSkincare').stop().slideDown(200);
      $('.drop-down__wrapper').css('height', 'auto');
    },
    function () {
      $('.ddmTargetSkincare').stop().slideUp(200);
      $('.drop-down__wrapper').css('height', 'initial');
    }
  );
  $('#drop-down-menu-VALX .valx-collaboration').hover(
    function () {
      $('.ddmTargetValx').stop().slideDown(200);
      $('.drop-down__wrapper').css('height', 'auto');
    },
    function () {
      $('.ddmTargetValx').stop().slideUp(200);
      $('.drop-down__wrapper').css('height', 'initial');
    }
  );
});
// headerドロップダウンメニュー sp
// 1階層目
$(function () {
  $('.site-header .ddmBtnSp1').on('click', function () {
    $(this).closest('li').find('.ddmTargetSp1').toggleClass('ddmTargetOn');
    $(this).find('.ddm__cont__ttl--plus').toggleClass('ddm__cont__ttl--minus');
  });
});

// footer アコーディオン sp
$(function () {
  $('.footer__nav .ddmBtnSp1').on('click', function () {
    $(this).closest('li').find('.ddmTargetSp1').toggleClass('ddmTargetOn');
    $(this).find('.ddm__cont__ttl--plus').toggleClass('ddm__cont__ttl--minus');
  });
  $('.footer__nav .ddmBtnSp2').on('click', function () {
    $(this).closest('li').find('.ddmTargetSp2').toggleClass('ddmTargetOn');
    $(this).find('.ddm__cont__ttl--plus').toggleClass('ddm__cont__ttl--minus');
  });
});

// スムーススクロール
$(function () {
  $('a[href*="#"]').click(function () {
    //先頭一致では動かないので部分一致にする
    var headerHight = 170; //ヘッダーの高さ指定
    var speed = 500; //スピード指定
    var href = $(this).attr('href').split('#').slice(-1); //クリックした要素のhrefを取得
    var target = $(href == '#' || href == '' ? 'html' : '#' + href); //移動先を指定
    var position = target.offset().top - headerHight; //ポジションからヘッダーの高さ分引く
    var w = $(window).width(); //レスポンシブ分岐用　ウインドウ幅取得
    if (w < 750) {
      // 749だとずれる　//スマホ版のヘッダー高さ指定
      headerHight = 60; //SP版は固定ヘッダーなし
    }
    $('html, body').animate(
      {
        scrollTop: position, //スムーススクロール実行
      },
      speed,
      'swing'
    );
    return false;
  });
});

// =================================================
// ハンバーガ実装
// =================================================
$(function () {
  $(
    'button.js-mobile-nav-toggle, .mobile-nav-wrapper li.ddm__item.ddm__item--sp>a'
  ).click(function () {
    $('#MobileNav').toggleClass('active');
    $('button.js-mobile-nav-toggle').toggleClass('mobile-nav--open');
    $('button.js-mobile-nav-toggle').toggleClass('mobile-nav--close');
    // return false;
  });
});
